<div *ngIf="pimProductConcept != null; else loading">
  <h4>{{ pimProductConcept?.name }}</h4>
  <div class="row">
    <div class="col-12 col-md-3">
      <lib-image-carousel
        *ngIf="pimProductConcept?.images"
        [openExternal]="true"
        [zoom]="false"
        [images]="pimProductConcept.images"
      ></lib-image-carousel>
    </div>
    <div class="col-12 col-md-9">
      <lib-simple-list
        *ngIf="pimProductConcept && configService.concept"
        #productList
        [configService]="configService"
      ></lib-simple-list>
    </div>
  </div>
</div>

<ng-template #loading>LOADING...</ng-template>
